import { Link } from 'react-router-dom';
import './CTASection.css';

export default function CTASection() {
  return (
    <section className="landing-section cta-section">
      <div className="landing-section-inner">
        <div className="cta-content animate-on-scroll">
          <div className="cta-mascot">
            <span className="mascot-wave">🦀</span>
            <span className="wave-hand">👋</span>
          </div>
          <h2 className="cta-title">Ready to meet your OpenClaw?</h2>
          <p className="cta-subtitle">
            Deploy your personal AI in the cloud in under 2 minutes.
            <br />
            No servers. No Docker. Just magic.
          </p>
          <Link to="/login" className="btn btn-primary btn-large cta-button">
            Get Started Now
            <span className="btn-icon">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
